// One CSV convention for every browser-made export, the same as the
// server-side exports (backend/listing.py, S2-31): ';' separated, decimal
// comma, dd.mm.yyyy days and a UTF-8 BOM, so Turkish Excel splits the
// columns and reads the amounts as numbers.

const ISO_DAY = /^(\d{4})-(\d{2})-(\d{2})$/;

/** 'YYYY-MM-DD' -> 'dd.mm.yyyy'; anything else unchanged. */
export const csvDate = (value) => {
  const m = ISO_DAY.exec(String(value ?? ''));
  return m ? `${m[3]}.${m[2]}.${m[1]}` : value;
};

/** One cell: numbers with a decimal comma (no grouping), ✓ for true,
 * quoted when it holds the separator, a quote or a line break. */
export const csvCell = (v) => {
  if (v === null || v === undefined) return '';
  let text;
  if (typeof v === 'boolean') text = v ? '✓' : '';
  else if (typeof v === 'number') text = Number.isFinite(v) ? String(v).replace('.', ',') : '';
  else text = String(v);
  return /[";\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

/** Rows (arrays of cells) as CSV text with the BOM. */
export const csvText = (rows) => `﻿${rows.map((row) => row.map(csvCell).join(';')).join('\r\n')}`;

/** Download rows as `<name>.csv`. */
export function downloadCsv(name, rows) {
  const blob = new Blob([csvText(rows)], { type: 'text/csv;charset=utf-8' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${name || 'liste'}.csv`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => window.URL.revokeObjectURL(url), 1000);
}
